import { render, staticRenderFns } from "./reportMessage.vue?vue&type=template&id=12c4286c&"
import script from "./reportMessage.vue?vue&type=script&lang=js&"
export * from "./reportMessage.vue?vue&type=script&lang=js&"
import style0 from "./reportMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports